'use client'

import Footer from './Footer'
import FooterSafe from './FooterSafe'
import { isSafeCountry } from '../../helpers/helpers'
import { useChromeless } from '../useChromeless'

const ClientFooterWrapper = () => {
  const safeCountry = isSafeCountry()
  const chromeless = useChromeless()

  // Inside the Telegram webview a sitemap footer is dead weight below a screen
  // the user is meant to tap once and close.
  if (chromeless) return null

  return safeCountry ? <FooterSafe /> : <Footer />
}

export default ClientFooterWrapper
